<!--
	TEMPLATE
-->
<template>
<div class="editable-options">
	<div v-if="!isEditView" :class="{'text-italic': label === '--'}"> {{ label }}</div>

	<div v-if="isEditView" class="editable-options__select" :class="{'editable-options__select--large': options.large}">
		<select v-model="selected" @change="changed">
			<option v-for="item in options.items" :value="typeof item[ID] == 'object' ? item[ID][0] : item[ID]">{{ item[TEXT] }}</option>
		</select>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';

export default {
	props: {
		value: [String, Number],
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			ID: 0,
			TEXT: 1
		}
	},
	computed: {
		isMultiple: function() {
			return this.value && this.value.constructor === Array;
		},
		label: function() {
			var that = this;
			var item = this.options.items.find(function(element) {
        if (typeof element[that.ID] == 'object') {
          return element[that.ID].indexOf(that.value) !== -1
        } else {
          return element[that.ID] === that.value
        }
			})
			return typeof item !== 'undefined' ? item[that.TEXT] : '--'
		},
		selected: vModelNested
	},
	methods: {
		changed: function() {
			console.log('has changed:' + this.label);
			this.$emit('changed');
		}
	},
	watch: {
		label: function() {
			console.log('label:' + this.label);
			this.hasErrors = this.label === '--';
			this.$emit('hasErrors', this.hasErrors);
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableOptions.vue